var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "yxt-switch",
        _vm._g(
          _vm._b(
            {
              attrs: { "active-value": 0, "inactive-value": 1 },
              model: {
                value: _vm.getValue,
                callback: function ($$v) {
                  _vm.getValue = $$v
                },
                expression: "getValue",
              },
            },
            "yxt-switch",
            _vm.$attrs.attrs,
            false
          ),
          _vm.$attrs.on
        )
      ),
      _c(
        "span",
        { staticClass: "tlive-create__switch--text tlive-create__tip" },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t(
                  "pc_biz_seePlayback" /* 开启后，员工可以观看直播回放视频 */
                )
              ) +
              "\n  "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }